<template>
	<div>
		<!-- Create Button Section -->
		<CRow>
			<CCol class="text-right mb-3">
				<router-link
					:to="{ name: ROUTE_NAME.BANNER_IN_SEARCH_CREATE }"
					class="btn btn-secondary mb-3"
				>
					<CIcon class="mr-2" name="cil-plus" />
					Create Banner in Search
				</router-link>
			</CCol>
		</CRow>
		<!-- End Create Button Section -->

		<!-- Search Section -->
		<CRow>
			<CCol>
				<form class="search-form" @submit.prevent="handleSearch">
					<CInput
						v-model.trim="queryParams.q"
						data-test-id="banner-in-search-search"
						type="text"
						placeholder="Search by banner in search name or ID"
					>
						<template #prepend-content>
							<button
								type="submit"
								class="btn-search"
							>
								<FontAwesomeIcon :icon="['far', 'search']" />
							</button>
						</template>
					</CInput>
				</form>
			</CCol>
		</CRow>
		<!-- End Search Section -->

		<!-- Search Footer Section -->
		<CRow class="mb-4">
			<CCol>
				<BaseSearchFormFooter
					:count="meta.total"
					append-text="Banner in search found"
					reset-filter-btn-text="Reset search"
					@onReset="resetFilter"
				/>
			</CCol>
		</CRow>
		<!-- End Search Footer Section -->

		<!-- Table Section -->
		<BaseTable
			:is-loading="isLoading"
			:fields="FIELDS"
			:items="list"
			:pagination="{
				pages: meta.lastPage,
				activePage: meta.currentPage,
			}"
			striped
			clickable-rows
			:link-to="ROUTE_NAME.BANNER_IN_SEARCH_EDIT"
			class="table-custom table-custom-link"
			data-test-id="banner-in-search-table"
			@onPaginationClick="handlePageChange"
		>
			<template #no-items-view>
				<div class="empty-table-element">
					<p class="subtitle">
						{{ $t("global.searchNotFound", { field: "Banner in search" }) }}
					</p>
				</div>
			</template>
			<template #name="{item}">
				<CRow data-test-id="banner-in-search-name">
					<CCol>{{ item }}</CCol>
				</CRow>
			</template>
			<template #previewPeriod="{item}">
				<CBadge
					class="badge-status"
					:color="item.color"
				>
					{{ item.label }}
				</CBadge>
			</template>
			<template #isActive="{item}">
				<CBadge class="badge-status" :color="STATUS_OBJECT[item].value">
					{{ STATUS_OBJECT[item].label }}
				</CBadge>
			</template>
		</BaseTable>
		<!-- End Table Section -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { ROUTE_NAME } from '../enums/route';
import { STATUS_OBJECT } from '../enums/status';

import { cleanObject } from '../assets/js/helpers';

const FIELDS = [
	{ key: 'id', label: 'ID', class: 'col-id' },
	{ key: 'name', label: 'Name', class: 'col-name th-mw-250' },
	{ key: 'previewStartAt', label: 'Start date', class: 'col-start-date' },
	{ key: 'previewEndAt', label: 'End date', class: 'col-end-date' },
	{ key: 'previewPeriod', label: 'Period', class: 'col-period' },
	{ key: 'isActive', label: 'Status', class: 'col-status' },
];

export default {
	name: 'SearchBanner',

	data() {
		return {
			FIELDS,
			ROUTE_NAME,
			STATUS_OBJECT,
			queryParams: {
				q: this.$route.query.q || null,
				page: Number(this.$route.query.page) || null,
			},
		};
	},

	computed: {
		...mapState('bannerInSearch', {
			isLoading: (state) => state.list.isLoading,
			list: (state) => state.list.data,
			meta: (state) => state.list.meta,
		}),
	},

	async created() {
		const params = {
			...this.queryParams,
		};
		await this.getBannerInSearches(params);
	},

	methods: {
		...mapActions({
			getBannerInSearches: 'bannerInSearch/getBannerInSearches',
		}),
		updateUrlParams() {
			const query = cleanObject(JSON.parse(JSON.stringify(this.queryParams)));
			this.$router.push({ query }).catch(() => {});
		},
		handleSearch() {
			this.$router.push({ query: { q: this.queryParams.q } }).catch(() => {});
		},
		resetFilter() {
			this.queryParams = {
				q: null,
				page: null,
			};

			this.updateUrlParams();
		},
		handlePageChange(page) {
			this.queryParams.page = page;
			this.updateUrlParams();
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
	min-width: rem(192);
}

.btn-search {
	background: transparent;
	box-shadow: none;
	border: none;
	padding: 0;
}
</style>